import React, { useState } from 'react';
import './ChangeLog.css';
import { logChangeLogOpen } from '../utils/analytics';

const ChangeLog = ({ editHistory }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expandedEntries, setExpandedEntries] = useState({});

  const handleOpen = () => {
    setIsOpen(true);
    logChangeLogOpen();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    return formatDate(dateString);
  };

  const getChangeIcon = (type) => {
    switch(type) {
      case 'add': return '➕';
      case 'update': return '✏️';
      case 'delete': return '❌';
      default: return '📝';
    }
  };

  const getChangeColor = (type) => {
    switch(type) {
      case 'add': return '#10b981';
      case 'update': return '#3b82f6';
      case 'delete': return '#ef4444';
      default: return '#6366f1';
    }
  };

  const toggleEntry = (index) => {
    setExpandedEntries(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const totalChanges = editHistory.reduce((sum, entry) => sum + entry.changes.length, 0);

  return (
    <>
      {/* Floating Button */}
      <button className="changelog-fab" onClick={handleOpen}>
        <span className="fab-icon">📋</span>
        {totalChanges > 0 && (
          <span className="fab-badge">{totalChanges}</span>
        )}
      </button>

      {/* Backdrop */}
      {isOpen && (
        <div className="changelog-backdrop" onClick={() => setIsOpen(false)} />
      )}

      {/* Dialog Box */}
      <div className={`changelog-dialog ${isOpen ? 'open' : ''}`}>
        <div className="changelog-dialog-header">
          <div className="changelog-title">
            <span className="changelog-icon">📋</span>
            <h3>Change Log</h3>
            <span className="total-changes-badge">{totalChanges} changes</span>
          </div>
          <button className="changelog-close-btn" onClick={() => setIsOpen(false)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path 
                d="M6 6L18 18M6 18L18 6" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="changelog-content">
          <div className="changelog-timeline">
            {editHistory.map((entry, index) => (
              <div key={index} className="timeline-entry">
                <div className="timeline-marker">
                  <div className="timeline-dot"></div>
                  {index < editHistory.length - 1 && <div className="timeline-line"></div>}
                </div>
                
                <div className="timeline-content">
                  <div 
                    className="entry-header"
                    onClick={() => toggleEntry(index)}
                  >
                    <div className="entry-info">
                      <span className="entry-date">{formatDate(entry.date)}</span>
                      <span className="entry-relative">{getRelativeTime(entry.date)}</span>
                      <span className="entry-changes-count">
                        {entry.changes.length} change{entry.changes.length !== 1 ? 's' : ''}
                      </span>
                    </div>
                    <button className="entry-expand-btn">
                      <svg 
                        className={`expand-arrow ${expandedEntries[index] ? 'expanded' : ''}`}
                        width="16" 
                        height="16" 
                        viewBox="0 0 16 16" 
                        fill="none"
                      >
                        <path 
                          d="M4 6L8 10L12 6" 
                          stroke="currentColor" 
                          strokeWidth="2" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  {expandedEntries[index] && (
                    <div className="changes-list">
                      {entry.changes.map((change, changeIndex) => (
                        <div 
                          key={changeIndex} 
                          className="change-item"
                          style={{ borderLeftColor: getChangeColor(change.type) }}
                        >
                          <span className="change-icon">{getChangeIcon(change.type)}</span>
                          <div className="change-details">
                            <strong>{change.company}</strong>
                            <p>{change.description}</p>
                          </div>
                          <span className="change-type-badge" style={{ backgroundColor: getChangeColor(change.type) }}>
                            {change.type}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangeLog;
